module.exports = __webpack_public_path__ + "img/ltkxprime-2x.48b5457.jpg";